import React, { Component } from "react";
import { IUiWorkflowViewPageState } from "../../../redux/modules/uiWorkflowViewPage/reducer";
import JumbotronLayout from "../../components/JumbotronLayout";
import { IWorkflow } from "../../../redux/modules/currentWorkflow/reducer";
import { getWorkflowLogo } from "../../../redux/modules/workflow/strings";
import { connect } from "react-redux";
import { GlobalState } from "../../../redux/modules/rootReducer";
import Alert from "../../components/Alert";
import {
  getCurrentCustomerId,
  getCurrentWorkflowId,
} from "../../../redux/modules/route/routes";

import { getWorkflowStateById } from "../../../redux/modules/workflow/reducer";

import WorkflowContainer from "./WorkflowContainer";
import {
  userClicksBackButton,
  userOpensWorkflowViewPage,
  userSubmitsWorkflowStep,
} from "./customerWorkflowViewPageScenarios";
import { AppDispatch } from "../../../store";
import AlignCenter from "../../components/AlignCenter";
import Throbber from "../../components/Throbber";
import BackButton from "../../components/NavBar/BackButton";
import OfficeAppButton from "../../components/NavBar/OfficeAppButton";
import { AclState } from "../../../acl/reducer";
import LogoutButton from "../../LogoutButton/LogoutButton";

interface ICustomerWorkflowViewPageProps {
  uiWorkflowViewPage: IUiWorkflowViewPageState;
  currentWorkflow: IWorkflow;
  route: string;
  dispatch: AppDispatch;
  aclState: AclState;
}

interface ICustomerWorkflowViewPageState {
  isComponentMounted: boolean;
}

class CustomerWorkflowViewPage extends Component<
  ICustomerWorkflowViewPageProps,
  ICustomerWorkflowViewPageState
> {
  state = {
    isComponentMounted: false,
  };

  async componentDidMount() {
    await this.props.dispatch(userOpensWorkflowViewPage());
    this.setState({
      isComponentMounted: true,
    });
  }

  render() {
    const { currentWorkflow, dispatch, route } = this.props;
    const customerId: string = getCurrentCustomerId(route);
    return (
      <JumbotronLayout
        title={
          currentWorkflow ? currentWorkflow.workflowInstanceDescription : null
        }
        iconPath={
          currentWorkflow
            ? getWorkflowLogo(currentWorkflow.workflowType.toUpperCase())
            : null
        }
        content={this.renderContent()}
        headerLeft={
          <BackButton
            label={"Sites"}
            onClick={() => dispatch(userClicksBackButton())}
          />
        }
        headerRight={
          <>
            <LogoutButton />
            <OfficeAppButton customerId={customerId} siteId={null} />
          </>
        }
      />
    );
  }

  renderContent() {
    const { uiWorkflowViewPage, currentWorkflow, route, dispatch } = this.props;
    const { isComponentMounted } = this.state;
    const customerId: string = getCurrentCustomerId(route);
    if (uiWorkflowViewPage.pageIsLoading || !isComponentMounted) {
      return (
        <AlignCenter>
          <Throbber />
        </AlignCenter>
      );
    }
    if (uiWorkflowViewPage.fatalError) {
      return <Alert>{uiWorkflowViewPage.fatalError}</Alert>;
    }
    if (currentWorkflow) {
      return (
        <WorkflowContainer
          workflow={currentWorkflow}
          customerId={customerId}
          siteId={null}
          onStepSubmit={(step, actions) =>
            dispatch(userSubmitsWorkflowStep(customerId, step, actions))
          }
        />
      );
    }
    if (isComponentMounted) {
      return <Alert>Unexpected branch {JSON.stringify(this.props)}</Alert>;
    }
    return null;
  }
}

export default connect((state: GlobalState) => {
  const workflowId = getCurrentWorkflowId(state.route);
  // @ts-ignore
  const workflowsState = state.workflows;
  const workflowState = getWorkflowStateById(workflowsState, workflowId);
  const workflow = workflowState && workflowState.entry;
  const workflowsPending = workflowsState.pending;
  const workflowError =
    workflowsState.error ||
    (workflowState && workflowState.errors && workflowState.errors[0]);

  return {
    uiWorkflowViewPage: {
      pageIsLoading: workflowsPending,
      fatalError: workflowError ? workflowError.message : null,
    },
    currentWorkflow: workflow,
    route: state.route,
    aclState: state.acl,
  };
})(CustomerWorkflowViewPage);
